export enum CompanyFinancialsTermFilterName {
  Quarter = 'quarter',
  Annual = 'annual',
}
